<template>
  <div class="transparent-tab">
    <div class="transparent-tab-btn-up" v-if="!visible">
      <a-button icon="double-right" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent_btn" v-if="visible">
      <div style="color: #fff; text-align: right; padding: 0 12px; font-size: 15px; cursor: pointer">
        <a-icon type="double-left" @click="handleOpenOrClose" />
      </div>
      <a-list item-layout="horizontal" :data-source="list1[0].customizeConfigDataList">
        <a-list-item slot="renderItem" slot-scope="item">
          <span>
            <img :src="setImg(item)" alt="" class="node_icon" />
          </span>
          <span>{{ filterDictTextByCache('node_type', item.nodeType) }}</span>
        </a-list-item>
      </a-list>
      <a-list item-layout="horizontal" :data-source="list2[0].customizeConfigDataList">
        <a-list-item slot="renderItem" slot-scope="item">
          <span style="flex: 1;">{{ item.minLimit || 0 }}</span>
          <span class="node_color" :style="{ background: item.colour }"></span>
          <span style="flex: 1;">{{ item.maxLimit || '∞' }}</span>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>
        
    <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JInput from '../../../../components/jeecg/JInput.vue'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import Vue from 'vue'
export default {
  name: 'modal',
  components: {
    JInput,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      title: this.$t('组件4'),
      width: 800,
      visible: true,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        getImg: window._CONFIG['domianURL'] + '/jeecg-gis/customizeConfigScheme/',
      },
      activeKey: '1',
      list1: [],
      list2: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let topologyTest = Vue.ls.get('GIS_TOPOLOGY_DATA') || {}
      this.list1 = topologyTest.customizeConfigList.filter(item => {
        return item.customizeConfigScheme.customizeType == 'CUSTOMIZE_CONFIG_TYPE_NODE_ICON'
      })
      this.list2 = topologyTest.customizeConfigList.filter(item => {
        return item.customizeConfigScheme.customizeType == 'CUSTOMIZE_CONFIG_TYPE_LINE_COMMON'
      })
    },
    handleChange(e) {
      this.activeKey = e.target.value
      let params = {
        activeKey: this.activeKey,
      }
      if (this.activeKey == 1) {
        params.type = 'CUSTOMIZE_CONFIG_TYPE_ZOOM_LEVEL'
      } else if (this.activeKey == 2) {
        params.type = 'CUSTOMIZE_CONFIG_TYPE_LINE_PRESSURE'
      } else if (this.activeKey == 3) {
        params.type = 'LIU_LIANG'
      } else if (this.activeKey == 4) {
        params.type = 'LIU_SU'
      }
      this.$emit('change', params)
    },
    setImg(item) {
      if (item.icon) {
        return this.url.getImg + item.icon
      }
    },
    handleOpenOrClose() {
      this.visible = !this.visible
    },
  },
}
</script>
<style lang="less" scoped>
.transparent-tab {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 2;
  background: rgba(70, 76, 92, 0.5);
}
.transparent-tab-btn-up {
  width: 100%;
  height: 40px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 999;
  text-align: center;
}
::v-deep .ant-list-split .ant-list-item {
  border: none;
  color: #fff;
  justify-content: flex-start;
  padding: 0 12px;
  line-height: 0.5;
  font-size: 12px;
}
.node_icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.node_color {
  width: 20px;
  height: 10px;
  display: inline-block;
  margin-right: 5px;
  margin-left: 5px;
}
::v-deep .ant-btn-primary {
  background-color: #464c5c;
  border-color: #464c5c;
}
</style>